import { DuplicateChecksModalProps } from 'components/EmployeeDetails/StatutoryContributions/components/DuplicateChecksModal';
import { getAppErrorDetails } from 'utils/AppError';

export const getGeneratedEmail = (orgId?: number) => {
  const timestamp = new Date().getTime();
  const email = `auto+${orgId}+${timestamp}@opfin.com`;
  return email;
};

export const getDuplicateDetails = (error: any) => {
  return error
    ? (getAppErrorDetails(error)?.otherDetails?.response?.errors?.[0]?.extensions?.response?.body
        ?.extraDetails as DuplicateChecksModalProps['details'])
    : undefined;
};

export const onboardingErrorMessages = {
  panExists: 'PAN already exists',
}